import { useState } from "react"
import { toast } from "sonner"
import { createUserAPI } from "@/apis/admin-api"
import { userStore } from "../admin-user-store"
import CreateLabel from "../../_components/create-form/create-label"
import CreateInput from "../../_components/create-form/create-input"
import CreateButton from "../../_components/create-form/create-button"
import Wrapper from "@/components/wrapper"

const CreateUserForm = ({ successAction }) => {
  const { apiAction } = userStore()

  const [form, setForm] = useState({
    user_id: "",
    user_name: "",
    password: "",
    confirmPassword: "",
    phone: "",
    scope_code: ""
  })

  const changeField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const createUser = async () => {
    if (form.password !== form.confirmPassword) {
      return toast.error("비밀번호가 일치하지 않습니다.")
    }

    if (!form.user_id.trim()) {
      return toast.error("아이디를 입력해주세요.")
    }

    if (!form.user_name.trim()) {
      return toast.error("이름을 입력해주세요.")
    }

    if (!form.password.trim()) {
      return toast.error("비밀번호를 입력해주세요.")
    }
    try {
      await createUserAPI({
        user_id: form.user_id.trim(),
        user_name: form.user_name.trim(),
        password: form.password,
        phone: form.phone.trim() || null,
        scope_code: form.scope_code.trim() || null
      })

      toast.success("유저가 생성되었습니다.")

      setForm({
        user_id: "",
        user_name: "",
        password: "",
        phone: "",
        scope_code: ""
      })

      await apiAction()

      successAction?.()
    } catch (err) {
      if (err?.response?.status === 400) {
        toast.error(err.response.data.detail)
      }
    }
  }

  return (
    <section className="space-y-6 py-4 px-2">
      <div className="ml-2">
        <h3 className="font-semibold">유저 생성</h3>
        <p className="mt-1 text-sm text-slate-500">소속 및 권한설정은 계정 생성 이후 가능합니다.</p>
      </div>

      <Wrapper.shadow>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <CreateLabel label={"아이디"} />

            <CreateInput
              placeholder="tester"
              value={form.user_id}
              onChange={(e) => changeField("user_id", e.target.value)}
            />
          </div>

          <div>
            <CreateLabel label={"이름"} />

            <CreateInput
              placeholder="홍길동"
              value={form.user_name}
              onChange={(e) => changeField("user_name", e.target.value)}
            />
          </div>

          <div>
            <CreateLabel label={"비밀번호"} />

            <CreateInput
              type="password"
              placeholder="비밀번호"
              value={form.password}
              onChange={(e) => changeField("password", e.target.value)}
            />
          </div>

          <div>
            <CreateLabel label={"비밀번호 확인"} />

            <CreateInput
              type="password"
              placeholder="비밀번호"
              value={form.confirmPassword}
              onChange={(e) => changeField("confirmPassword", e.target.value)}
            />
          </div>

          <div>
            <CreateLabel label={"전화번호 (선택)"} />

            <CreateInput
              placeholder="010-0000-0000"
              value={form.phone}
              onChange={(e) => changeField("phone", e.target.value)}
            />
          </div>

          <div>
            <CreateLabel label={"소속 코드 (선택)"} />

            <CreateInput
              placeholder="A10023006"
              value={form.scope_code}
              onChange={(e) => changeField("scope_code", e.target.value)}
            />

            <p className="ml-2 mt-1 text-sm text-gray-400">비워두면 비활성 상태로 생성됩니다.</p>
          </div>
        </div>

        <div className="mt-4 flex justify-end">
          <CreateButton onClick={createUser}>유저 생성</CreateButton>
        </div>
      </Wrapper.shadow>
    </section>
  )
}

export default CreateUserForm
